"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./Form.module.css"));
var Welcome_1 = require("./form/Welcome");
var WelcomeES_1 = require("./form/WelcomeES");
function Form(props) {
    var isPdf = false;
    var isDependent = props.isDependent;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement("div", { id: "beonair_financial_aid_estimate", className: styles.containerPosition + " " + styles.pageBreak },
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
        react_1.default.createElement("div", { className: "" + styles.pageSize }, props.idiom === "ES" ? react_1.default.createElement(WelcomeES_1.WelcomeES, null) : react_1.default.createElement(Welcome_1.Welcome, null))));
}
exports.Form = Form;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybS5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9Wb2d1ZS9Gb3JtLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLHdEQUEyQztBQUUzQywwQ0FBc0M7QUFDdEMsOENBQTBDO0FBRTFDLFNBQWdCLElBQUksQ0FBQyxLQUFLO0lBQ3RCLElBQUksS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUNWLElBQUEsK0JBQVcsQ0FBUztJQUMzQixJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUU7UUFDZCxLQUFLLEdBQUcsSUFBSSxDQUFBO0tBQ2Y7SUFFRCxPQUFPLENBQ0gsdUNBQ0ksRUFBRSxFQUFDLGdDQUFnQyxFQUNuQyxTQUFTLEVBQUssTUFBTSxDQUFDLGlCQUFpQixTQUFJLE1BQU0sQ0FBQyxTQUFXO1FBQzNELENBQUMsS0FBSyxJQUFJLHVDQUFLLFNBQVMsRUFBRSxlQUFhLE1BQU0sQ0FBQyxXQUFhLEdBQVE7UUFDcEUsdUNBQUssU0FBUyxFQUFFLEtBQUcsTUFBTSxDQUFDLFFBQVUsSUFDL0IsS0FBSyxDQUFDLEtBQUssS0FBSyxJQUFJLENBQUMsQ0FBQyxDQUFDLDhCQUFDLHFCQUFTLE9BQUcsQ0FBQyxDQUFDLENBQUMsOEJBQUMsaUJBQU8sT0FBRyxDQUNqRCxDQUNKLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFqQkQsb0JBaUJDIn0=